import { useUID } from 'react-uid';
import { useTranslation } from 'react-i18next';
import Modal from '../../../components/Modal';
import { css } from '@emotion/react';
import { Button, Flex } from '../../../components';
import colors from '../../../lib/colors';
import styled from '@emotion/styled';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onContinue: () => void;
}

const FreeGameWarningDialog = ({ isOpen, onClose, onContinue }: Props) => {
  const modalHeadingId = useUID();
  const [t] = useTranslation();
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      aria={{
        labelledby: modalHeadingId,
      }}
      css={css`
        .Overlay {
          z-index: 10;
        }
        .Modal {
          background-color: ${colors.darkBlueBackground}
          };
        }
      `}
    >
      <Flex p={4} flexDirection="column" alignItems="center">
        <Title>{t('freeGameWarning.title', 'Upozornění')}</Title>
        <Text id={modalHeadingId}>
          {t(
            'freeGameWarning.text',
            'Máte naplánované školení. Volná hra se vám nebude započítávat pro jeho splnění.',
          )}
        </Text>
        <Flex mt={'1em'} justifyContent="center">
          <Flex display="inline-flex" flexDirection="column">
            <Button
              extraWide
              variant="warning"
              labelT={{
                key: 'freeGameWarning.continue',
                defaultValue: 'Pokračovat',
              }}
              onClick={onContinue}
            />
            <Button
              extraWide
              labelT={{
                key: 'freeGameWarning.back',
                defaultValue: 'Zpět',
              }}
              onClick={onClose}
              focus={true}
              css={css`
                background: none;
                color: ${colors.warning};
                border: 2px solid ${colors.warning};
                margin-top: 16px;
                width: 100%;
              `}
            />
          </Flex>
        </Flex>
      </Flex>
    </Modal>
  );
};

export default FreeGameWarningDialog;

const Title = styled.p`
  font-size: 1.5rem;
  font-weight: bold;
  color: white;
  text-align: center;
  line-height: 2;
`;

const Text = styled.p`
  font-size: 0.75rem;
  color: white;
  text-align: center;
  line-height: 1.4;
  padding: 0;
  margin: 0 0 24px 0;
`;
